<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroTrinappSearch" />
    <!--Section :content="basics" />
    <Section :content="logic" /-->
    <CallToAction :content="buildingCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'TrinAppSearch',
  components: {
    MainNavBar,
    Hero,
    Section,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroTrinappSearch: { 
        eyebrow: '',
        header: 'Search API',
        subheader: 'As easy to use as a Google search box but focused on only the information needed, whether across all pods or only inside the current pod. Text searches return highly relevant results within Unit of Thought contexts, and system tag searches return all linked objects to that system. All results include the full object hierarchy up for easy navigation and discovery.',
        img: 'search-image.png',
        videoId: '',
        buttons: [
          /*{ label: 'Basics', path: '', id: 'basics' },
          { label: 'Logic', path: '', id: 'logic' },
          { label: 'Modes', path: '', id: '' },
          { label: 'Pod Context', path: '', id: '' },
          { label: 'Response', path: '', id: '' },*/
        ]
      },
      basics: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Basics',
        paragraphs: [
          'Simple API at /search/ with url encoded query' +
          'Wildcard * supported, for example: ' + 
          'https://porsche.trinpod.us/search/solid https://porsche.trinpod.us/search/solid%20rocks https://porsche.trinpod.us/search/solid%20rock%2'
        ],
        id: 'basics',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
      },
      logic: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Logic',
        paragraphs: [
          'term  triggers Or (search results may include term) ' + 
          '+term  triggers And (search results must include term) ' + 
          '-term  triggers Not (search results must not include term) ' + 
          'For example: solid -server +app*  => /search/solid%20-server%20%2Bapp%2A'
        ],
        id: 'basics',
        image: 'placeholder.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      buildingCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
